import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DepositPaymentModal = ({ open, onClose }) => {
  const [uploading, setUploading] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        await axios.post(`${API_URL}/api/documents/upload`, {
          stage_index: 4,
          document_name: 'Deposit Payment Receipt',
          document_type: file.type,
          file_data: reader.result
        });
        toast.success('Deposit payment receipt uploaded successfully!');
        onClose();
      } catch (error) {
        toast.error('Failed to upload receipt');
      } finally {
        setUploading(false);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading font-semibold text-2xl">Deposit Payment</DialogTitle>
          <p className="text-muted-foreground">Upload your deposit payment receipt</p>
        </DialogHeader>

        <div className="space-y-4">
          <div className="p-6 rounded-xl bg-muted text-center space-y-4">
            <div className="space-y-2">
              <Label htmlFor="receipt">Payment Receipt</Label>
              <Input
                id="receipt"
                type="file"
                accept="image/*,.pdf"
                onChange={handleFileUpload}
                disabled={uploading}
                className="rounded-xl"
              />
              <p className="text-xs text-muted-foreground">Upload bank receipt or transaction proof</p>
            </div>
          </div>

          <div className="p-4 rounded-xl bg-info/10 border border-info/20">
            <p className="text-sm text-info-foreground">
              <strong>Note:</strong> Please ensure your receipt clearly shows:
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Transaction date</li>
                <li>Amount paid</li>
                <li>University name</li>
                <li>Your name</li>
              </ul>
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DepositPaymentModal;